const routes = [
  {
    url: 'seaux',
    name: 'Parc de Seaux',
    nbImages: 13
  },
  {
    url: 'buren',
    name: 'Colonnes de Buren',
    nbImages: 10
  },
  {
    url: 'plaisance',
    name: 'Plaisance',
    nbImages: 15
  },
  {
    url: 'caroussel',
    name: 'Caroussel du Louvres',
    nbImages: 25
  },
]

export default routes